
import InstituteTable from '../table.vue'
import ScrollTo from '@/components/scroll_to/index.vue'
import FullLoading from '@/components/full_loading/index.vue'
import ScrollToType from '@/components/scroll_to/type'
import { CommonService } from '@/services'
import { Component, Vue, Ref } from 'vue-property-decorator'

type Pannel = 'data' | 'flow' | 'api'

export const Types = [
    { key: 0, name: '全部' },
    { key: 1, name: '研究报告' },
    { key: 2, name: '影响力周榜' },
    { key: 3, name: '影响力月榜' },
    { key: 4, name: '牛媒专访' }
]

@Component({
    name: 'institute',
    components: {
        InstituteTable,
        ScrollTo,
        FullLoading
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType

    private pageSize = 15
    private pageIndex = 1
    private pageTotal = 0
    private isLoading = true
    private instituteList: any[] = []
    private curType = 0
    private onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.getInstitute)
    }

    private async mounted() {
        this.isLoading = true
        await this.getInstitute()
        this.isLoading = false   
    }

    /** 获取数据报告列表 */
    private async getInstitute() {
        const params = {
            type: this.curType,
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        const result = await CommonService.getInstituteList(params)
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.instituteList = result.data.list
        }
    }

    // 删除
    private onDelete(institute: any) {
        this.$confirm('你正在删除该数据报告, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.deleteInstitute(institute)
        })
    }

    private async deleteInstitute(institute: any) {
        this.isLoading = true
        const params = { id: institute.id }
        const result = await CommonService.deleteInstitute(params)
        this.isLoading = false
        if (result.status === 200) {
            this.instituteList.splice(this.instituteList.indexOf(institute), 1)
            this.$message({
                type: 'success',
                message: '删除成功',
                showClose: true
            })
            return
        }
        this.$message({
            type: 'error',
            message: result.message || '发生错误, 请稍后再试',
            showClose: true
        })
    }
}
